<h3 class="h3" *ngIf="legendTitle">{{ legendTitle | translate }}</h3>
<div class="block-charts-container">
  <ul *ngIf="visible && legendColorClasses.length" class="list-chart">
    <li *ngFor="let item of data; let i = index" class="list-chart-item" [ngClass]="[legendColorClasses[i]]">
      <span>{{ labels[i] }}: {{ data[i] }} - </span>
      <span>
        <b>{{ (data[i] * 100) / data.reduce(totalSum) | number : '1.2-3' }} %</b>
      </span>
    </li>
  </ul>
  <div *ngIf="visible; else noData" class="block-charts" [style.height.px]="options.height">
    <canvas baseChart [type]="charType" [labels]="labels" [datasets]="canvasDataset" [options]="options"> </canvas>
  </div>
  <ng-template #noData>
    <div>{{ 'nouns.empty' | translate }}</div></ng-template
  >
</div>
